import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import type { VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@/lib/utils';

/*
 * shadcn badge, restyled to the prototype's pixel chips (Silkscreen, zero
 * radius). `success` is the green "registered/live" badge; `live` adds the
 * leading dot at the call site.
 */
const badgeVariants = cva(
  'inline-flex items-center justify-center gap-1 whitespace-nowrap border font-display text-[9px] uppercase tracking-wide px-2 py-0.5 w-fit shrink-0',
  {
    variants: {
      variant: {
        default: 'border-line bg-panel-in text-text',
        success: 'border-badge-bd bg-badge-bg text-badge-tx',
        gold: 'border-line bg-panel-in text-gold',
        orange: 'bevel-orange bg-orange-cta text-orange-cta-tx',
        outline: 'border-bev-l text-text',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

function Badge({
  className,
  variant,
  asChild = false,
  ...props
}: React.ComponentProps<'span'> & VariantProps<typeof badgeVariants> & { asChild?: boolean }) {
  const Comp = asChild ? Slot : 'span';
  return (
    <Comp data-slot="badge" className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export { Badge, badgeVariants };
